module.exports = __webpack_public_path__ + "assets/images/spor_fm_tv3_logo.7635f9ed53a6c1788131320fa46680a6.png";